import { useRequest } from "@prismicio/editor-support/Suspense"
import { ErrorBoundary, Text } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { getRepositoryName } from "../../app/routing"
import { getAllEnvironments } from "../../app/services/environments"

export function RepositoryTitle() {
  return (
    <ErrorBoundary
      renderError={() => <Text variant="bold">{getRepositoryName()}</Text>}
    >
      <Suspense fallback={<Text variant="bold">{getRepositoryName()}</Text>}>
        <EnvironmentTitle />
      </Suspense>
    </ErrorBoundary>
  )
}

function EnvironmentTitle() {
  const environments = useRequest(getAllEnvironments, [])

  if (environments.results.length === 0) return null

  const repositoryName = getRepositoryName()
  const currentEnvironment = environments.results.find(
    (env) => env.domain === repositoryName
  )

  return (
    <Text variant="bold">{currentEnvironment?.name ?? repositoryName}</Text>
  )
}
